import moment from 'moment';
import {ICommonUtilInterface} from '../common/common-util.interface';


export abstract class TranscodingItem {
  protected constructor(
    public id: string,
    public videoTitle: string,
    public videoTenantUniqueId: string,
    public videoDurationMs: number,
    public startTimeMs: number,
    public endTimeMs: number,
    public status: EMediaTranscodingItemStatus,
    public statusesLogs: string,
    public lastStatusTime: moment.Moment,
    public resultUrl: string,
  ) {}

  public abstract clone(utils: ICommonUtilInterface): TranscodingItem;
  public abstract asRequest(): {};

}


export enum EMediaTranscodingItemStatus {
  Pending = 0,
  InEngineQueue,
  Running,
  Finished,
  Failed,
  Aborted,
  DeliveredToDestinations,
}
